import { useMemo } from "react";
import { createApiClient, type ApiClient } from "@/api/client";
import { getApiBaseUrl } from "@/api/config";
import { useSession } from "@/auth/useSession";

export function useApiClient(): ApiClient {
  const { accessToken } = useSession();
  return useMemo(
    () =>
      createApiClient({
        baseUrl: getApiBaseUrl(),
        getAccessToken: () => accessToken,
        getCorrelationId: () => crypto.randomUUID(),
      }),
    [accessToken],
  );
}
